<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <div class="left_nav ex_w">
          <div class="nav_title">
            {{ classTitle }}
          </div>
          <ul class="nav_item">
            <li
              :class="item.id === setIndex ? 'on' : ''"
              v-for="(item, index) in middleClassItem"
              :key="index"
              @click="midlleClass(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="right_con">
          <div class="all_class">
            <div v-for="(item, index) in SmallClassList" :key="index">
              <product-item :option="1" :item="item" :middleId="setIndex" />
            </div>
          </div>
          <el-empty description="暂无数据" v-if="SmallClassList.length<=0"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumb from '../../components/bread-crumb/Index.vue'
import productItem from '../../components/product_item.vue'
import { posts } from '../../utils/posts'
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
export default {
  name: '产品中心',
  components: {
    crumb,
    productItem
  },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const userInfo = store.state.userInfo || { uid: 0 }
    const setIndex = ref(0) // 中类ID
    const classTitle = ref('')
    classTitle.value = route.query.name
    const bigClassId = ref(0)
    bigClassId.value = route.query.bigClassId // 大类ID
    const middleClassItem = ref([])
    const SmallClassList = ref([])
    // 获取中类
    const getmiddleclasssecond = () => {
      posts('classes/getmiddleclasssecond/' + userInfo.uid, {
        bigClassId: bigClassId.value
      }).then((res) => {
        middleClassItem.value = res.data
        setIndex.value = route.query.middleClassId * 1 || res.data[0].id
        smallClassHandler()
      })
    }
    // 根据大类获取中类和小类
    const smallClassHandler = () => {
      posts('classes/getSmallClassWithProductCount/' + userInfo.uid, {
        middleClassId: setIndex.value
      }).then((res) => {
        SmallClassList.value = res.data
      })
    }

    // 根据获取中类
    const midlleClass = (val) => {
      setIndex.value = val.id
      smallClassHandler()
      router.push({
        path: '/product/proCenter',
        query: {
          bigClassId: bigClassId.value,
          name: route.query.name,
          middleClassId: val.id
        }
      })
    }

    onMounted(() => {
      getmiddleclasssecond()
      smallClassHandler()
    })
    return {
      bigClassId,
      classTitle,
      userInfo,
      midlleClass,
      setIndex,
      getmiddleclasssecond,
      smallClassHandler,
      middleClassItem,
      SmallClassList
    }
  }
}
</script>
<style lang="scss" scoped>
.all_class {
  width: 967px;
  margin: 33px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.left_nav {
  width: 182px;
  .nav_item {
    margin: 36px 0 0 0;
    li {
      height: 24px;
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
      color: #666666;
      margin: 0 0 12px 0;
      cursor: pointer;
      &:hover {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        color: #3e3a39;
      }
      &.on {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        color: #3e3a39;
      }
    }
  }
  .nav_title {
    font-size: 34px;
    font-weight: 600;
    line-height: 46px;
    color: #3e3a39;
    .title_bg {
      padding: 0 20px;
      height: 64px;
      line-height: 64px;
      text-align: center;
      background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
      opacity: 1;
      border-radius: 5px;
      color: white;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        width: 14px;
        height: 14px;
        background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
        left: 0;
        right: 0;
        bottom: -7px;
        margin: auto;
        transform: rotate(45deg);
      }
    }
  }
  &.ex_w {
    width: 208px;
  }
}
.container {
  width: 1200px;
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 0 0;
}
</style>
